import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GooglePlacesDirective } from '../../directives/google-places.directive';

@Component({
  selector: 'formly-google-address',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormlyModule,
    GooglePlacesDirective,
  ],
  template: `
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>{{ props.label }}</mat-label>
      <input
        matInput
        googleAddressAutoComplete
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="props.required"
        [placeholder]="props.placeholder || ''"
        (onSelectAddress)="onAddressSelected($event)"
      />
      <mat-error *ngIf="formControl.invalid && formControl.touched">
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
    </mat-form-field>
  `,
})
export class GoogleAddressType extends FieldType<FieldTypeConfig> {
  onAddressSelected(result: any): void {
    // Call the callback provided via props if it exists
    if (this.props.onAddressSelect) {
      this.props.onAddressSelect(result);
    }
  }
}